import { useMutation } from '@apollo/client';
import user from 'client/queries/user';
import mutation from 'client/mutations/register';

export default function useRegister() {
  const options = {
    refetchQueries: [{ query: user }]
  };

  return useMutation(mutation, options);
}
